import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface IMenuItem {
	type: string;
	name?: string;
	state?: string;
	icon?: string;
	tooltip?: string;
	disabled?: boolean;
	sub?: IChildItem[];
	badges?: IBadge[];
	itr?: [];
}
interface IChildItem {
	type?: string;
	name: string;
	state?: string;
	icon?: string;
	sub?: IChildItem[];
	itr?: [];
}

interface IBadge {
	color: string;
	value: string;
}

@Injectable()
export class NavigationService {

	iconMenu: any = [];
	tempIconMenu = [
		{
			name: 'Part A - General',
			type: 'dropDown',
			tooltip: 'Dashboard',
			icon: 'add_box',
			state: 'dashboard',
			itr: [1, 2, 3, 4, 5],
			sub: [
				{ name: 'Personal Information', state: 'part-general/personal-information', itr: [1, 2, 3, 4, 5], sub: [], error: false },
				{ name: `Partner's / Member's / Trust Information`, state: 'part-general/pmt-information', itr: [5], sub: [], error: false },
				{ name: 'Banking Information', state: 'part-general/banking-information', itr: [1, 2, 3, 4, 5], sub: [], error: false },
				{ name: 'Filing Status', state: 'part-general/filing-information', itr: [1, 2, 3, 4, 5], sub: [], error: false },
				{ name: 'Other Details', state: 'part-general/other-details', itr: [2, 3, 5], sub: [], error: false },
				{ name: 'Schedule 5A ', state: 'part-general/schedule5a', itr: [2, 3], sub: [], error: false },
				{ name: 'Audit Information', state: 'part-general/audit-information', itr: [3, 5], sub: [], error: false },
			],
			error: false,
		},
		{
			name: 'Part A - General - 1',
			type: 'dropDown',
			tooltip: 'Dashboard',
			icon: 'add_box',
			state: 'dashboard',
			itr: [6],
			sub: [
				{ name: 'Personal Information', state: 'part-general/personal-information', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
				{ name: `Partner's / Member's / Trust Information`, state: 'part-general/pmt-information', itr: [5], sub: [], error: false },
				{ name: 'Banking Information', state: 'part-general/banking-information', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
				{ name: 'Filing Status', state: 'part-general/filing-information', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
				{ name: 'Other Details', state: 'part-general/other-details', itr: [2, 3, 5], sub: [], error: false },
				{ name: 'Schedule 5A ', state: 'part-general/schedule5a', itr: [2, 3], sub: [], error: false },
				{ name: 'Audit Information', state: 'part-general/audit-information', itr: [3, 5, 6], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Part A - General - 2',
			type: 'dropDown',
			tooltip: 'Dashboard',
			icon: 'add_box',
			state: 'dashboard',
			itr: [6],
			sub: [
				{ name: 'Schedule SH1', state: 'part-general/shareholding-of-unlisted-company', itr: [6], sub: [], error: false },
				{ name: 'Schedule SH2', state: 'part-general/shareholding-of-start-ups', itr: [6], sub: [], error: false },
				{ name: 'Holding Status', state: 'part-general/holding-status', itr: [6], sub: [], error: false },
				{ name: 'Business Organisation', state: 'part-general/business-organisation', itr: [6], sub: [], error: false },
				{ name: 'Key Persons', state: 'part-general/key-persons', itr: [6], sub: [], error: false },
				{ name: 'Share-Holders Information', state: 'part-general/shareholders-information', itr: [6], sub: [], error: false },
				{ name: 'Ownership Information', state: 'part-general/ownership-information', itr: [6], sub: [], error: false },
				{ name: 'Nature Of Company and Its Business', state: 'part-general/nature-company-business', itr: [6], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Financial Information',
			type: 'dropDown',
			tooltip: 'Shop',
			icon: 'add_box',
			state: 'dashboard/financial-information',
			itr: [2, 3, 5, 6],
			sub: [
				{ name: 'Schedule FA', state: 'schedule-fa', itr: [2, 3, 5, 6], sub: [], error: false },
				{ name: 'Schedule AL', state: 'schedule-al', itr: [2, 3], sub: [], error: false },

				{ name: 'Schedule FD', state: 'schedule-fd', itr: [6], sub: [], error: false },
				{ name: 'Schedule AL1', state: 'schedule-al-one', itr: [6], sub: [], error: false },
				{ name: 'Schedule AL2', state: 'schedule-al-two', itr: [6], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Business Information',
			type: 'dropDown',
			tooltip: 'Multi Level',
			icon: 'add_box',
			state: 'dashboard/business-information',
			itr: [3, 5, 6],
			sub: [
				{
					name: 'Financial Statements',
					state: 'financial-statements',
					type: 'dropDown',
					itr: [3, 5, 6],
					sub: [
						{ name: 'Profit & Loss', state: 'profit-loss', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Manufacturing Account', state: 'mfg', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Trading Account', state: 'trading-account', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Balance Sheet', state: 'balance-sheet', itr: [3, 5], sub: [], error: false },
						{ name: 'Balance Sheet', state: 'balance-sheet6', itr: [6], sub: [], error: false },
					],
					error: false
				},
				{
					name: 'Other Information',
					state: 'other-information',
					type: 'dropDown',
					itr: [3, 5, 6],
					sub: [
						{ name: 'Quantitative Details', state: 'quantitative-details', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Nature Of Business', state: 'nature-of-business', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Schedule ICDS', state: 'schedule-icds', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Schedule IF', state: 'schedule-if', itr: [3, 5], sub: [], error: false },
						{ name: 'Others Information', state: 'others-information', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Receipt and Payment', state: 'receipt-payment', itr: [1, 2, 4, 6], sub: [], error: false },
					],
					error: false
				},
			],
			error: false
		},
		{
			name: 'Incomes',
			type: 'dropDown',
			tooltip: 'Multi Level',
			icon: 'add_box',
			state: 'dashboard/incomes',
			itr: [1, 2, 3, 4, 5, 6],
			sub: [
				{
					name: 'Salary Income',
					state: 'salary-income',
					type: 'dropDown',
					itr: [1, 2, 3, 4],
					sub: [
						{ name: 'Employer ', state: 'employer', itr: [1, 2, 3, 4], sub: [], error: false },
						{ name: 'Salary As Per Form 16', state: 'salary-as-per-form-16', itr: [1, 2, 3, 4], sub: [], error: false },
						{ name: 'Salary ITR Mode', state: 'salary-itr-mode', itr: [1, 2, 3, 4], sub: [], error: false },
					],
					error: false
				},
				{
					name: 'House Property',
					state: 'house-property',
					type: 'dropDown',
					itr: [1, 2, 3, 4, 5, 6],
					sub: [
						{ name: 'House Property', state: 'house-property-details', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
					],
					error: false
				},
				{
					name: 'Business and professional Income',
					state: 'business-professional-income',
					type: 'dropDown',
					itr: [3, 4, 5, 6],
					sub: [
						{ name: 'Schedule BP', state: 'schedule-bp', itr: [3, 4, 5, 6], sub: [], error: false },
						{ name: 'Schedule GST', state: 'schedule-gst', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Schedule DPM & DOA', state: 'schedule-dpm-doa', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Schedule DEP', state: 'schedule-dep', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Schedule DCG', state: 'schedule-dcg', itr: [3, 5, 6], sub: [], error: false },
						{ name: 'Schedule ESR', state: 'schedule-esr', itr: [3, 5, 6], sub: [], error: false },
					],
					error: false
				},
				{
					name: 'Capital Gains Income',
					state: 'capital-gains-income',
					type: 'dropDown',
					itr: [2, 3, 5, 6],
					sub: [
						{ name: 'Data Input', state: 'data-input', itr: [2, 3, 5, 6], sub: [], error: false },
						{ name: 'CG Setoff', state: 'cg-setoff', itr: [2, 3, 5, 6], sub: [], error: false },
						{ name: 'Accrual Receipt', state: 'accrual-receipt', itr: [2, 3, 5, 6], sub: [], error: false },
					],
					error: false
				},
				{
					name: 'Income From Other Sources',
					state: 'income-form-other-sources',
					type: 'dropDown',
					itr: [1, 2, 3, 4, 5, 6],
					sub: [
						{ name: 'Income From Other Sources', state: 'income-form-other-sources', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
						{ name: 'Accrual Receipt', state: 'accrual-receipt', itr: [1,2, 3, 4, 5, 6], sub: [], error: false },
					],
					error: false
				},
				{
					name: 'Schedule PTI',
					state: 'schedule-pti',
					itr: [2, 3, 5, 6],
					sub: [],
					error: false
				},
				{
					name: 'Exempt Income',
					state: 'exempt-income',
					itr: [1, 2, 3, 4, 5, 6],
					sub: [],
					error: false
				},
				{
					name: 'Clubbing Income',
					state: 'clubbing-income',
					itr: [2, 3],
					sub: [],
					error: false
				},
				{
					name: 'Shedule ESOP',
					state: 'shedule-esop',
					itr: [2, 3],
					sub: [],
					error: false
				},
			],
			error: false
		},
		{
			name: 'Loss Set Off',
			state: 'dashboard/loss-set-off',
			type: 'dropDown',
			icon: 'add_box',
			itr: [2, 3, 5, 6],
			sub: [
				{ name: 'CYLA', state: 'cyla', itr: [2, 3, 5, 6], sub: [], error: false },
				{ name: 'BFLA', state: 'bfla', itr: [2, 3, 5, 6], sub: [], error: false },
				{ name: 'CFL', state: 'cfl', itr: [2, 3, 5, 6], sub: [], error: false },
				{ name: 'UD', state: 'ud', itr: [3, 5, 6], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Deductions',
			state: 'dashboard/deduction',
			type: 'dropDown',
			icon: 'add_box',
			itr: [1, 2, 3, 4, 5, 6],
			sub: [
				{ name: 'General Deduction (Schedule VIA)', state: 'general-deduction', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
				{ name: 'Business Deduction (Schedule VIA)', state: 'business-deduction', itr: [3, 5, 6], sub: [], error: false },
				{ name: 'Schedule 10AA', state: '10aa-deduction', itr: [3, 5, 6], sub: [], error: false },
				{ name: 'Schedule RA', state: 'ra-deduction', itr: [3, 5, 6], sub: [], error: false },
				{ name: 'Schedule DI', state: 'schedule-di', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Relief and Rebate',
			state: 'dashboard/relief-rebate',
			type: 'dropDown',
			icon: 'add_box',
			itr: [2, 3, 5, 6],
			sub: [
				{ name: 'Schedule FSI', state: 'schedule-fsi', itr: [2, 3, 5, 6], sub: [], error: false },
				{ name: 'Schedule TR', state: 'schedule-tr', itr: [2, 3, 5, 6], sub: [], error: false },
				{ name: 'Relief u/s 89', state: 'relief-89-u-s', itr: [3], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Taxes Paid',
			state: 'dashboard/taxes-paid',
			type: 'dropDown',
			icon: 'add_box',
			itr: [1, 2, 3, 4, 5, 6],
			sub: [
				{ name: 'Schedule IT', state: 'schedule-it', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
				{
					name: 'TDS',
					state: 'tax-deducted',
					type: 'dropDown',
					itr: [1, 2, 3, 4, 5, 6],
					sub: [
						{ name: 'TDS-1', state: 'tds-1', itr: [1, 2, 3, 4], sub: [], error: false },
						{ name: 'TDS-2', state: 'tds-2', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
						{ name: 'TDS-3', state: 'tds-3', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
					],
					error: false
				},
				{ name: 'TCS', state: 'tax-collect', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
				{ name: 'Schedule DDT', state: 'schedule-ddt', itr: [6], sub: [], error: false },
				{ name: 'Schedule BBS', state: 'schedule-bbs', itr: [6], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Schedule TPSA',
			state: 'dashboard/schedule-tpsa',
			type: 'dropDown',
			icon: 'add_box',
			itr: [3, 5, 6],
			sub: [
				{ name: 'Schedule TPSA', state: 'schedule-tpsa', itr: [3, 5, 6], sub: [], error: false },
			],
			error: false
		},
		{
			name: 'Computation and E-filing',
			state: 'dashboard/computation-return',
			type: 'dropDown',
			icon: 'add_box',
			itr: [1, 2, 3, 4, 5, 6],
			sub: [
				{
					name: 'Computation Display',
					state: 'computation-display',
					type: 'dropDown',
					itr: [1, 2, 3, 4, 5, 6],
					sub: [
						{ name: 'BTI-BTTI', state: 'bti-btti', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false },
						{ name: 'Schedule SI', state: 'schedule-si', itr: [2, 3, 5, 6], sub: [], error: false },
						{ name: 'AMT/AMTC', state: 'amt', itr: [2, 3, 5], sub: [], error: false },
						{ name: 'MAT/MATC', state: 'mat', itr: [6], sub: [], error: false },
					],
					error: false
				},
				{ name: 'Signing Person Info', state: 'sigining-person-info', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false, isDisabled: true },
				{ name: 'Return Filing', state: 'return-filing', itr: [1, 2, 3, 4, 5, 6], sub: [], error: false, isDisabled: true },
			],
			error: false
		},
	];
	iconTypeMenuTitle = 'Frequently Accessed';
	menuItems = new BehaviorSubject<IMenuItem[]>(this.iconMenu);
	menuItems$ = this.menuItems.asObservable();
	finalList = [];

	constructor() {
	}

	publishNavigationChange(menuType: string) {
		switch (menuType) {
			case 'separator-menu':
				this.menuItems.next(this.iconMenu);
				break;
			case 'icon-menu':
				this.menuItems.next(this.iconMenu);
				break;
			default:
				this.menuItems.next(this.iconMenu);
		}
	}

	initSideMenu(id) {
		const newList = this.tempIconMenu.slice();
		this.finalList = [];
		newList.forEach(levelOneElement => {
			const levelOneItrList = levelOneElement['itr'];
			const levelOneItrFound = levelOneItrList.indexOf(id) > -1 ? true : false;
			if (levelOneItrFound) {
				const levelOneObj = Object.assign({}, levelOneElement);
				const levelOneSubExist = levelOneObj.hasOwnProperty('sub');
				if (levelOneSubExist && levelOneObj['sub'].length) {
					const levelOneAllSub = [];
					levelOneObj['sub'].forEach(levelTwoElement => {
						const levelTwoItrList = levelTwoElement['itr'];
						const levelTwoItrFound = levelTwoItrList.indexOf(id) > -1 ? true : false;
						if (levelTwoItrFound) {
							const levelTwoObj = Object.assign({}, levelTwoElement);
							const levelTwoSubExist = levelTwoObj.hasOwnProperty('sub');
							if (levelTwoSubExist && levelTwoObj['sub'].length) {
								const levelTwoAllSub = [];
								levelTwoObj['sub'].forEach(levelThreeElement => {
									const levelThreeItrList = levelThreeElement['itr'];
									const levelThreeItrFound = levelThreeItrList.indexOf(id) > -1 ? true : false;
									if (levelThreeItrFound) {
										const levelThreeObj = Object.assign({}, levelThreeElement);
										const levelThreeSubExist = levelTwoObj.hasOwnProperty('sub');
										if (levelThreeSubExist && levelThreeObj['sub'].length) {
										} else {
											levelTwoAllSub.push(levelThreeObj);
										}
									}
								});
								levelTwoObj['sub'] = levelTwoAllSub;
								levelOneAllSub.push(levelTwoObj);
							} else {
								levelOneAllSub.push(levelTwoObj);
							}
						}
					});
					levelOneObj['sub'] = levelOneAllSub;
					this.finalList.push(levelOneObj);
				} else {
					this.finalList.push(levelOneObj);
				}
			}
		});
		this.menuItems.next(this.finalList);
	}

	updateError(state, value) {
		this.finalList.forEach(levelOneElement => {
			if (levelOneElement['state'] === state) {
				levelOneElement['error'] = value;
			}
			levelOneElement['sub'].forEach(levelTwoElement => {
				if (levelTwoElement['state'] === state) {
					levelTwoElement['error'] = value;
				}
				levelTwoElement['sub'].forEach(levelThreeElement => {
					if (levelThreeElement['state'] === state) {
						levelThreeElement['error'] = value;
					}
					levelThreeElement['sub'].forEach(levelFourElement => {
						if (levelFourElement['state'] === state) {
							levelFourElement['error'] = value;
						}
					});
				});
			});
		});
		this.menuItems.next(this.finalList);
	}
}